import { PredefinedIcons } from '@dealstack/frontend/shared/components/fundament/Icon/Icon.types.ts';
import { Flex, Text } from '@mantine/core';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { InvestorDetailsEmptyCardStateStyles } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/InvestorDetailsEmptyCardState/InvestorDetailsEmptyCardState.styles.tsx';

interface Props {
	title: string;
	description?: string;
	icon: PredefinedIcons;
	dataTestId?: string;
}

export const InvestorDetailsEmptyCardState = ({ title, description, icon, dataTestId }: Props) => {
	return (
		<InvestorDetailsEmptyCardStateStyles data-testid={dataTestId}>
			<Flex direction="column" align="center" justify="center">
				<Flex align="center" justify="center">
					<Icon variant={icon} size="4xl" />
				</Flex>

				<Text fw={600} c="dark.8" ta="center">
					{title}
				</Text>

				{description && (
					<Text fz={12} c="dark.0" ta="center">
						{description}
					</Text>
				)}
			</Flex>
		</InvestorDetailsEmptyCardStateStyles>
	);
};
